import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/index.css";
import { I18nProvider } from "@/lib/i18n";
import { AuthProvider } from "@/lib/auth";
import { CartProvider } from "@/lib/cart";
import Header from "@/components/Header";
import CartDrawer from "@/components/CartDrawer";
import Home from "@/pages/Home";
import Books from "@/pages/Books";
import Shop from "@/pages/Shop";
import Events from "@/pages/Events";
import About from "@/pages/About";
import Profile from "@/pages/Profile";
import Library from "@/pages/Library";
import Dashboard from "@/pages/Dashboard";
import Reader from "@/pages/Reader";
import Login from "@/pages/Login";
import Contact from "@/pages/Contact";
import Saadhna from "@/pages/Saadhna";
import EventDetail from "@/pages/EventDetail";
import SiteGate from "@/components/SiteGate";
import FloatingDoodles from "@/components/FloatingDoodles";

export default function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <div className="min-h-screen paper text-foreground">
              <FloatingDoodles />
              <Header />
              <SiteGate>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/books" element={<Books />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/saadhna" element={<Saadhna />} />
                <Route path="/events" element={<Events />} />
                <Route path="/events/:eid" element={<EventDetail />} />
                <Route path="/about" element={<About />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/library" element={<Library />} />
                <Route path="/reader/:bookId" element={<Reader />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/login" element={<Login />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
              </SiteGate>
              <footer className="border-t border-[#E8DEC8] mt-16 py-8 text-center text-sm text-[#6E6259]">
                <div className="divider-om max-w-3xl mx-auto mb-3"><span className="font-serif text-lg">ॐ</span></div>
                <p className="font-serif text-[#5C061C] text-lg">Shri Vidya Sadhana Seva Sanstha</p>
                <p className="mt-1">Flat 502, B Wing, Prakruti Pearl CHS, Hiranandani Estate, Thane West, Maharashtra 400607</p>
                <p className="mt-1">Trust Regn. MAH/670/2018/Thane · shrividhya104@gmail.com · +91 99208 33345</p>
                <p className="mt-1 text-[#B45309]">All payments are non-refundable · Product pickup at Sanstha office only</p>
              </footer>
              <CartDrawer />
              <Toaster position="top-center" richColors />
            </div>
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </I18nProvider>
  );
}
